export class MessageDto {
    public user: string = '';
    public msgText: string = '';
}
